import { Modal } from "@/components/elements/Modal";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type NativeNotificationModalProps = {
  open: boolean;
  title: string;
  body: string;
  onConfirm: () => void;
};

export const NativeNotificationModal = ({ open, title, body, onConfirm }: NativeNotificationModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={open}
      onOk={onConfirm}
      onClose={onConfirm}
      labelOk={t("common.confirm")}
      title={title}
      enableCloseIcon={true}
      hiddenCloseBtn
      preventCloseBackdrop
    >
      <Box my={2} maxHeight="60vh" overflow="auto">
        <Typography variant="body14" whiteSpace="pre-wrap">
          {body}
        </Typography>
      </Box>
    </Modal>
  );
};
